import Dog from './Dog.js';
import Member from './Member.js';
import Node from './Node.js';

export default class DogMemberRelation {
    static fromData(data) {
        if (!data) {
            return;
        }

        const relation = new DogMemberRelation();
        relation.id = data.id;
        relation.association = data.association;
        relation.dog = Dog.fromData(data.dog.data);
        relation.member = new Member();
        if (data.member) {
            relation.member.id = data.member.id;
            relation.member.firstName = data.member.firstName;
            relation.member.lastName = data.member.lastName;
            relation.member.gender = data.member.gender;
            relation.member.hasAvatar = data.member.hasAvatar;
            relation.member.avatarFileName = data.member.avatarFileName;
        }

        return relation;
    }

    static fromFileData(data) {
        if (!data) {
            return;
        }

        const relation = new DogMemberRelation();
        relation.id = data.id;
        relation.association = data.association;
        relation.dog = Dog.fromData(data.dog);
        relation.nodes = data.nodes.map((node) => Node.fromData(node));

        return relation;
    }
}
